import * as React from "react";
import { IBcheck } from "src/services/interfaces/Compliance/IBcheck";
import { BcheckIcon } from "../Icons/Bcheck/BcheckIcon";
import { Spin } from 'antd';
import { DataGrid } from 'devextreme-react';
import { Column } from 'devextreme-react/data-grid';
import { IBCheckModal } from "src/services/interfaces/Compliance/IBCheckModal";
import { ModalSpcView } from "./ModalSpcView";
import { Ispc } from "src/services/interfaces/Compliance/Credito/ISpc";
import { BcheckTypeLabel } from "./BcheckType";

interface IViewTradeBCheckModal {
  isLoading: boolean;
  compliances: IBCheckModal[];
  showCompliance: boolean;
  showCredit: boolean;
}

export const ViewTradeBCheckModal: React.FC<IViewTradeBCheckModal> = ({ isLoading, compliances, showCompliance, showCredit }) => {

  function GetBcheckIcon(response: string) {
    return <>{!!response && <BcheckIcon response={response} />}</>;
  }

  return (
    <React.Fragment>
      <Spin spinning={isLoading}>
        <DataGrid dataSource={compliances} showBorders columnAutoWidth>
          <Column caption="Tipo" alignment={"center"} dataType="string">
            <Column caption="#" alignment={"center"} width={"82px"} dataField="responsible" dataType="string" cellRender={params => BcheckTypeLabel.get(params.data.responsible)} />
            <Column caption="CPF/CNPJ" alignment={"center"} dataField="cpfCnpj" dataType="string" />
          </Column>
          <Column caption="Crédito" alignment={"center"} dataType="string">
            <Column visible={showCredit} caption="CNDT" alignment={"center"} dataField="credit.cndt" dataType="string">
              <Column
                caption="Status"
                alignment={"center"}
                width={"100px"}
                dataField="credit.cndt.isApproved"
                cellRender={params => {
                  const dataParam: IBcheck = params.data.credit?.cndt;
                  return <>{GetBcheckIcon(dataParam?.response)}</>;
                }}
              />
            </Column>
            <Column visible={showCredit} caption="SPC" alignment={"center"} dataField="credit.spc" dataType="string">
              <Column
                caption="Status"
                alignment={"center"}
                width={"100px"}
                dataField="credit.spc.isApproved"
                cellRender={params => {
                  const dataParam: Ispc = params.data.credit?.spc;
                  return <>{GetBcheckIcon(dataParam?.response)}</>;
                }}
              />
              <Column
                caption="Pesquisa"
                alignment={"center"}
                width={"100px"}
                dataField="credit.spc"
                dataType="data"
                visible={compliances.some(c => c.credit?.spc?.response === "Hit")}
                cellRender={params => {
                  const dataType = params.data.credit?.spc;
                  return <>{dataType.response === "Hit" &&
                    <ModalSpcView spc={dataType} />
                  }</>;
                }}
              />
            </Column>
            <Column visible={showCredit} caption="PGFN" alignment={"center"} dataField="credit.pgfn" dataType="string">
              <Column
                caption="Status"
                alignment={"center"}
                width={"100px"}
                dataField="credit.pgfn.isApproved"
                cellRender={params => {
                  const dataParam: IBcheck = params.data.credit?.pgfn;
                  return <>{GetBcheckIcon(dataParam?.response)}</>;
                }}
              />
            </Column>
            <Column visible={showCredit} caption="CND Estadual (Não obrigatório)" alignment={"center"} dataField="credit.certidaoDebitosEstadual" dataType="string">
              <Column
                caption="Status"
                alignment={"center"}
                width={"100px"}
                dataField="credit.certidaoDebitosEstadual.isApproved"
                cellRender={params => {
                  const dataParam: IBcheck = params.data.credit?.certidaoDebitosEstadual;
                  return <>{GetBcheckIcon(dataParam?.response)}</>;
                }}
              />
            </Column>
          </Column>
          <Column caption="Compliance" alignment={"center"} dataType="string">
            <Column visible={showCompliance} caption="RECEITA" alignment={"center"} dataField="compliance.rfStatus" dataType="string">
              <Column
                caption="Status"
                alignment={"center"}
                width={"100px"}
                dataField="compliance.rfStatus.isApproved"
                cellRender={params => {
                  const dataParam: IBcheck = params.data.compliance?.rfStatus;

                  return <>{GetBcheckIcon(dataParam?.response)}</>;
                }}
              />
            </Column>
            <Column visible={showCompliance} caption="PEP" alignment={"center"} dataField="compliance.pep" dataType="string">
              <Column
                caption="Status"
                alignment={"center"}
                width={"100px"}
                dataField="compliance.pep.isApproved"
                cellRender={params => {
                  const dataParam: IBcheck = params.data.compliance?.pep;
                  return <>{GetBcheckIcon(dataParam?.response)}</>;
                }}
              />
            </Column>
            <Column visible={showCompliance} caption="MEDIA" alignment={"center"} dataField="compliance.media" dataType="string">
              <Column
                caption="Status"
                alignment={"center"}
                width={"100px"}
                dataField="compliance.media.isApproved"
                cellRender={params => {
                  const dataParam: IBcheck = params.data.compliance?.media;
                  return <>{GetBcheckIcon(dataParam?.response)}</>;
                }}
              />
            </Column>
            <Column visible={showCompliance} caption="PROCESSOS" alignment={"center"} dataField="compliance.process" dataType="string">
              <Column
                caption="Status"
                alignment="center"
                width="100px"
                dataField="compliance.process.isApproved"
                cellRender={params => GetBcheckIcon(params.data.compliance?.process)}
              />
            </Column>
            <Column visible={showCompliance} caption="Representante Legal" alignment={"center"} dataField="compliance.legalRepresentative" dataType="string">
              <Column
                caption="Status"
                alignment={"center"}
                width={"100px"}
                dataField="compliance.legalRepresentative.isApproved"
                cellRender={params => {
                  const dataParam: IBcheck = params.data.compliance?.legalRepresentative;
                  return <>{GetBcheckIcon(dataParam?.response)}</>;
                }}
              />
            </Column>
          </Column>
        </DataGrid>
      </Spin>
    </React.Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/components/common/BcheckView/ViewTradeBCheckModal.tsx